<template>
    <div v-show="visible" class="back-top" @click="scrollToTop">
        <slot>
            <div class="back-top-content">
                <i class="back-top-icon el-icon-arrow-up"></i>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        visibilityHeight: {
            type: Number,
            default: 400
        }
    },
    data() {
        return {
            visible: false
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, false);
        window.addEventListener('resize', this.handleScroll, false);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, false);
        window.removeEventListener('resize', this.handleScroll, false);
    },
    methods: {
        getScroll(w, top) {
            let ret = w[`page${top ? 'Y' : 'X'}Offset`];
            const method = `scroll${top ? 'Top' : 'Left'}`;
            if (typeof ret !== 'number') {
                const d = w.document;
                // ie6,7,8 standard mode
                ret = d.documentElement[method];
                if (typeof ret !== 'number') {
                    // quirks mode
                    ret = d.body[method];
                }
            }
            return ret;
        },
        handleScroll() {
            let scrollTop = this.getScroll(window, true);
            this.visible = scrollTop > this.visibilityHeight;
        },
        scrollToTop() {
            let timer = setInterval(() => {
                let scrollTop = this.getScroll(window, true);
                let ispeed = Math.floor(-scrollTop / 6);
                window.scrollTo(0, scrollTop + ispeed);
                if (scrollTop === 0) {
                    clearInterval(timer);
                }
            }, 20);
            this.$emit('on-click');
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.back-top {
    z-index: 10;
    position: fixed;
    right: 10px;
    bottom: 70px;
    height: 40px;
    width: 40px;
    cursor: pointer;
    opacity: 0.7;
}

.back-top-content {
    height: 40px;
    width: 40px;
    background-color: #191919;
    color: #fff;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover {
        background-color: rgba(64, 64, 64, 0.6);
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
}

.back-top-icon {
    font-size: 20px;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppBackTop.vue